import ApiService from "@/core/services/api.service";
import Vue from "vue";

// action types
export const POPULATE_ACTIVITY_FAVOURITE_ENGAGEMENTS_LIST =
  "populateActivityFavouriteEngagementsList";
export const POPULATE_ACTIVITY_FAVOURITE_ENGAGEMENTS_INFO =
  "populateActivityFavouriteEngagementsInfo";
export const CREATE_FAVOURITE_ENGAGEMENTS = "createFavouriteEngagements";
export const UPDATE_FAVOURITE_ENGAGEMENTS = "updateFavouriteEngagements";
export const DELETE_FAVOURITE_ENGAGEMENTS = "deleteFavouriteEngagements";
export const CLEAR_FAVOURITE_ENGAGEMENTS_LIST = "clearFavouriteEngagementsList";
export const CLEAR_FAVOURITE_ENGAGEMENTS_INFO = "clearFavouriteEngagementsInfo";
export const CLEAR_FAVOURITE_ENGAGEMENTS_ERRORS = "clearFavouriteEngagementsErrors";

// mutation types
export const SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_LIST =
  "setActivityFavouriteEngagementsList";
export const RESET_ACTIVITY_FAVOURITE_ENGAGEMENTS_LIST =
  "resetActivityFavouriteEngagementsList";
export const SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_INFO =
  "setActivityFavouriteEngagementsInfo";
export const RESET_ACTIVITY_FAVOURITE_ENGAGEMENTS_INFO =
  "resetActivityFavouriteEngagementsInfo";
export const ADD_ACTIVITY_FAVOURITE_ENGAGEMENTS = "addActivityFavouriteEngagements";
export const UPDATE_ACTIVITY_FAVOURITE_ENGAGEMENTS = "updateActivityFavouriteEngagements";
export const REMOVE_ACTIVITY_FAVOURITE_ENGAGEMENTS = "removeActivityFavouriteEngagements";
export const SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS =
  "setActivityFavouriteEngagementsErrors";
export const RESET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS =
  "resetActivityFavouriteEngagementsErrors";

const state = {
  activity_favourite_engagements_errors: {},
  activity_favourite_engagements_list: [],
  activity_favourite_engagements_info: []
};

const getters = {
  activityFavouriteEngagementsErrors(state) {
    return state.activity_favourite_engagements_errors;
  },
  activityFavouriteEngagementsList(state) {
    return state.activity_favourite_engagements_list;
  },
  activityFavouriteEngagementsInfo(state) {
    return state.activity_favourite_engagements_info;
  }
};

const actions = {
  [POPULATE_ACTIVITY_FAVOURITE_ENGAGEMENTS_LIST](context, payload) {
    return ApiService.get(
      "api/v1/activities/" + payload.activityId + "/activity_response_favourites",
      {
        params: payload.params
      }
    )
      .then(res => {
        const responses = res.data.data._embedded.activity_favourite_engagements;
        context.commit(SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_LIST, responses);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [POPULATE_ACTIVITY_FAVOURITE_ENGAGEMENTS_INFO](context, payload) {
    return ApiService.get(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_response_favourites" +
        payload.activityFavouriteEngagementId,
      {
        params: payload.params
      }
    )
      .then(res => {
        const response = res.data.data;
        context.commit(SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_INFO, response);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [CREATE_FAVOURITE_ENGAGEMENTS](context, payload) {
    return ApiService.post(
      "api/v1/activities/" + payload.activityId + "/activity_response_favourites",
      payload.data
    )
      .then(res => {
        context.commit(ADD_ACTIVITY_FAVOURITE_ENGAGEMENTS, res.data.data);
        return res.data.data;
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [UPDATE_FAVOURITE_ENGAGEMENTS](context, payload) {
    return ApiService.put(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_response_favourites" +
        payload.activityFavouriteEngagementId,
      payload.data
    )
      .then(res => {
        const response = res.data.data;
        context.commit(SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_INFO, response);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [DELETE_FAVOURITE_ENGAGEMENTS](context, payload) {
    return ApiService.delete(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_response_favourites/" +
        payload.activityFavouriteEngagementId
    )
      .then(res => {
        Vue.$log.info("deleted");
        Vue.$log.info(res);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [CLEAR_FAVOURITE_ENGAGEMENTS_LIST](context) {
    context.commit(RESET_ACTIVITY_FAVOURITE_ENGAGEMENTS_LIST);
  },
  [CLEAR_FAVOURITE_ENGAGEMENTS_INFO](context) {
    context.commit(RESET_ACTIVITY_FAVOURITE_ENGAGEMENTS_INFO);
  },
  [CLEAR_FAVOURITE_ENGAGEMENTS_ERRORS](context) {
    context.commit(RESET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS);
  }
};

const mutations = {
  [SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_LIST](state, activity_favourite_engagements_list) {
    state.activity_favourite_engagements_list = activity_favourite_engagements_list;
  },
  [RESET_ACTIVITY_FAVOURITE_ENGAGEMENTS_LIST](state) {
    state.activity_favourite_engagements_list = [];
  },
  [SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_INFO](state, activity_favourite_engagements_info) {
    state.activity_favourite_engagements_info = activity_favourite_engagements_info;
  },
  [RESET_ACTIVITY_FAVOURITE_ENGAGEMENTS_INFO](state) {
    state.activity_favourite_engagements_info = [];
  },
  [ADD_ACTIVITY_FAVOURITE_ENGAGEMENTS](state, activity_favourite_engagements_info) {
    state.activity_favourite_engagements_list.push(activity_favourite_engagements_info);
  },
  [UPDATE_ACTIVITY_FAVOURITE_ENGAGEMENTS](state, activity_favourite_engagements_info) {
    let newActivityFavouriteEngagementsArray = [];
    newActivityFavouriteEngagementsArray.push(activity_favourite_engagements_info);
    state.activity_favourite_engagements_list = state.activity_favourite_engagements_list.map(
      obj => newActivityFavouriteEngagementsArray.find(o => o.id === obj.id) || obj
    );
  },
  [REMOVE_ACTIVITY_FAVOURITE_ENGAGEMENTS](state, activityFavouriteEngagementId) {
    state.activity_favourite_engagements_list = state.activity_favourite_engagements_list.filter(
      function(obj) {
        return obj.id !== activityFavouriteEngagementId;
      }
    );
  },
  [SET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS](
    state,
    activity_favourite_engagements_errors
  ) {
    state.activity_favourite_engagements_errors = activity_favourite_engagements_errors;
  },
  [RESET_ACTIVITY_FAVOURITE_ENGAGEMENTS_ERRORS](state) {
    state.activity_favourite_engagements_errors = [];
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
